import { produce } from 'immer';
import { TARIFF_TYPE } from '../../services/personalAdapter';
import { UPDATE_PERSONAL_DETAIL, SET_PERSONAL_INFO_DROPDOWN, UPDATE_INCOMEPROOF_DETAIL, SET_INCOMEPROOF_INFO_DROPDOWN, GET_NOMINEE_GENDER, GET_NOMINEE_RELATIONSHIP, GET_NOMINEE_TYPE, GET_PERSONAL_DETAILS_USEQUITY, SET_PERSONAL_INFO_USEQUITY_DROPDOWN, GET_PERSONAL_INFO_USEQUITY, GET_NOMINEE_DOCUMENT_TYPE, GET_SELECTEDSEGMENT, GET_DPTARIFF, SET_DP_SCHEME, DP_SCHEME_CHANGE, DP_SCHEME_SAVED, DP_SCHEME_SAVE_FAILED } from '../types/personal';

// CRM (branch) "DP Scheme" dropdown. `selected` is what the <select> displays;
// `confirmed` is server truth. The displayed value is only ever overwritten by
// (a) the user, (b) the response of the LATEST save, or (c) a revert to
// `confirmed` when the latest save fails. Responses to superseded saves update
// `confirmed` only (the server did apply them), so a later revert lands on the
// real stored value. `lastSeq` drops any out-of-order response, same idea as the
// journey reducer's stale-snapshot guard.
export const initialDpScheme = {
    show: false,
    options: [],
    selected: '',
    confirmed: '',
    saving: false,
    lastSeq: 0,
};

const initialState = {
    personalDetails: null,
    dropDownValues: null,
    incomeProofDetails: null,
    incomeDropDownValues: null,
    getNomineeType: null,
    // personalDetailsUsEquity: null,
    getPersonalDetailsUsEquityDropdown: null,
    getPersonalInfoUsEquity: null,
    selectedSegment: null,
    dpTariff: null,
    dpScheme: initialDpScheme,
}

const reducer = produce((state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case UPDATE_PERSONAL_DETAIL:
            state.personalDetails = payload;
            return;
        case SET_PERSONAL_INFO_DROPDOWN:
            state.dropDownValues = payload;
            return;
        case UPDATE_INCOMEPROOF_DETAIL:
            state.incomeProofDetails = payload;
            return;
        case SET_INCOMEPROOF_INFO_DROPDOWN:
            state.incomeDropDownValues = payload;
            return;
        case GET_NOMINEE_GENDER:
            state.getNomineeGender = payload;
            return;
        case GET_NOMINEE_DOCUMENT_TYPE:
            state.getNomineeDocumentType = payload;
            return;
        case GET_NOMINEE_RELATIONSHIP:
            state.getNomineeRelationship = payload;
            return;
        case GET_NOMINEE_TYPE:
            state.getNomineeType = payload;
            return;
        // case GET_PERSONAL_DETAILS_USEQUITY:
        //     state.personalDetailsUsEquity = payload;
        //     return;
        case SET_PERSONAL_INFO_USEQUITY_DROPDOWN:
            state.getPersonalDetailsUsEquityDropdown = payload;
            return;
        case GET_PERSONAL_INFO_USEQUITY:
            state.getPersonalInfoUsEquity = payload;
            return;
        case GET_SELECTEDSEGMENT:
            state.selectedSegment = payload;
            return;
        case GET_DPTARIFF: {
            const prev = state.dpTariff;
            const next = payload || null;
            // A DP-scheme save answers with the refreshed standard rows and, for now,
            // no partner block. Adopting that wholesale would flip a franchisee
            // (PARTNER) lead onto the standard table the moment it changed its own
            // scheme, so keep the partner rows and refresh only the standard ones.
            // A payload that does carry partner rows replaces both, as on page load.
            if (next && !next.partner && prev && prev.type === TARIFF_TYPE.PARTNER && prev.partner) {
                state.dpTariff = { ...prev, standard: next.standard };
                return;
            }
            state.dpTariff = next;
            return;
        }
        case SET_DP_SCHEME: {
            const next = payload || initialDpScheme;
            state.dpScheme = {
                show: !!next.show,
                options: Array.isArray(next.options) ? next.options : [],
                selected: next.selected || '',
                confirmed: next.selected || '',
                saving: false,
                lastSeq: 0,
            };
            return;
        }
        case DP_SCHEME_CHANGE: {
            if (!state.dpScheme) return;
            state.dpScheme.selected = payload.value;
            state.dpScheme.saving = true;
            return;
        }
        case DP_SCHEME_SAVED: {
            const d = state.dpScheme;
            if (!d || payload.seq < d.lastSeq) return;   // out-of-order response — ignore
            d.lastSeq = payload.seq;
            // The server's answer is truth whether it applied this value or a newer one
            // (applied:false carries the stored value, e.g. a second tab won).
            if (payload.selectedDpScheme) d.confirmed = payload.selectedDpScheme;
            if (payload.isLatest) {
                d.selected = d.confirmed;
                d.saving = false;
            }
            return;
        }
        case DP_SCHEME_SAVE_FAILED: {
            const d = state.dpScheme;
            if (!d || payload.seq < d.lastSeq) return;
            d.lastSeq = payload.seq;
            if (payload.isLatest) {
                d.selected = d.confirmed;   // revert to what the server actually holds
                d.saving = false;
            }
            return;
        }
        default:
            return state;
    }
})

export default reducer;